import { render } from "./BaseHeader.vue?vue&type=template&id=7f2f7480&scoped=true"
import script from "./BaseHeader.vue?vue&type=script&lang=js"
export * from "./BaseHeader.vue?vue&type=script&lang=js"

import "./BaseHeader.vue?vue&type=style&index=0&id=7f2f7480&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2f7480"],['__file',"src/components/header/BaseHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f2f7480"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f2f7480', __exports__)) {
    api.reload('7f2f7480', __exports__)
  }
  
  module.hot.accept("./BaseHeader.vue?vue&type=template&id=7f2f7480&scoped=true", () => {
    api.rerender('7f2f7480', render)
  })

}


export default __exports__